import { IState } from '../../../../../../store/types';
import { getCallLangOptions } from '../../../../selectors/getCallLangOptions';
import { LangUtil } from '../../../../../../../common/utils/lang-util';
import { BOOK_LANGUAGES } from '../constants';
import { TBookLangOption } from '../components/types';

// The lesson language picker's list, narrowed to what endless-book can write; one entry per book language.
export const getBookLangOptions = (state: IState): TBookLangOption[] => {
	const seen = new Set<string>();
	const options: TBookLangOption[] = [];
	for (const o of getCallLangOptions(state)) {
		const bookName = LangUtil.getEndlessBookName(o.code);
		if (!BOOK_LANGUAGES.includes(bookName) || seen.has(bookName)) continue;
		seen.add(bookName);
		options.push({ ...o, bookName, itemsCount: o.itemsCount ?? null });
	}
	return options;
};
